import { existsFilter } from '@iotv/core-services';
import { flattenArray, sortByTimestamp } from '@iotv/datamodel-core';
import { SortOrder } from '@iotv/iotv-v3-types';
import ApiGateway from '../../aws/api-gateway/ApiGateway';
import { Sources } from '../sourceSettings';
const debug = process.env.REACT_APP_DEBUG && false;
const queryPath = 'deviceMessagesInLastNMinutes';
const source = Sources.S3Athena;
const pathPrefix = source === Sources.S3Athena ? 'bi' : 'timestream';
export const getDeviceMessages = async ({ userSelectedGroup, deviceEuis, fromDateValue, toDateValue }) => {
    const path = `/${pathPrefix}/${queryPath}`;
    const params = { fromTimestampMs: fromDateValue.unix() * 1000, toTimestampMs: toDateValue.unix() * 1000, deviceEuis };
    debug && console.log('INFO: getDeviceMessages posting', { path, params });
    const res = { err: null, data: null };
    const { err, data, NextToken, QueryExecutionId } = (await ApiGateway.post(path, params, 'NetworkApi'));
    if (err) {
        res.err = err;
    }
    if (NextToken) {
        res.NextToken = NextToken;
        res.QueryExecutionId = QueryExecutionId;
    }
    if (data) {
        debug && console.log('Device message data', { data, NextToken, QueryExecutionId });
        res.data = flattenArray(data).sort((a, b) => sortByTimestamp(a, b, SortOrder.DESCENDING));
    }
    return res;
};
const maxIterations = 100;
export const iterateGetDeviceMessages = async (iteration = 0, queryRequest, previousRes = { err: null, data: null, NextToken: undefined }) => {
    const { userSelectedGroup, deviceEuis, fromDateValue, toDateValue, NextToken: NextTokenIn } = queryRequest;
    const { err: iterationErr, data: iterationData, NextToken, } = await getDeviceMessages({ userSelectedGroup, deviceEuis, fromDateValue, toDateValue, NextToken: NextTokenIn });
    if (iterationErr) {
        debug && console.log('iterateGetDeviceMessages err', iterationErr?.message);
        previousRes.err = new Error([previousRes.err?.message, iterationErr.message].filter(existsFilter).join(', '));
    }
    if (iterationData) {
        previousRes.data = [...(previousRes.data ?? []), ...iterationData];
        previousRes.data.sort(sortByTimestamp);
        if (NextToken) {
            if (iteration < maxIterations) {
                if (iterationData?.length === 0) {
                    console.log(`API returned zero results but a NextToken`);
                }
                console.log(`iterateGetDeviceMessages NextToken ${NextToken} iteration ${iteration}`);
                // previousRes = await iterateGetDeviceMessages(iteration + 1, { ...queryRequest, NextToken }, previousRes)
            }
            else {
                console.log(`iterateGetDeviceMessages reached max iterations ${maxIterations}`);
            }
        }
    }
    return previousRes;
};
